import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./layouts/style.css";
import "./layouts/normalize.css";
import LoginPage from "./features/auth/pages/LoginPage";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
import HomePage from "./features/home/HomePage";
import MainLayout from "./layouts/MainLayout";
import LessonDetails from "./features/lessons/pages/LessonDetails";
import LessonsList from "./features/lessons/pages/LessonsList";
import MyLessons from "./features/lessons/pages/MyLessons";
import ProfilePage from "./features/profile/ProfilePage";
import EditProfile from "./features/profile/EditProfile";
import LessonPlayer from "./features/lessons/pages/LessonPlayer";
import { useEffect } from "react";
import ExamPage from "./features/assessments/exams/ExamPage";
import ExamsList from "./features/assessments/exams/ExamsList";
import HomeworksList from "./features/assessments/homeworks/HomeworksList";
import HomeworkPage from "./features/assessments/homeworks/HomeworkPage";
import AssessmentResult from "./features/assessments/pages/AssessmentResult";
import "plyr/dist/plyr.css";
import ResultsPage from "./features/assessments/pages/ResultsPage";
function App() {
  useEffect(() => {
    document.documentElement.lang = "en";
    document.documentElement.setAttribute("translate", "no");
  }, []);
  useEffect(() => {
    const disableContextMenu = (e) => {
      // e.preventDefault();
    };

    //   const handleKeyDown = (e) => {
    //     if (
    //       e.key === "F12" ||
    //       (e.ctrlKey && e.shiftKey && ["I", "C", "J"].includes(e.key)) ||
    //       (e.ctrlKey && e.key === "U".includes(e.key))
    //     ) {
    //       e.preventDefault();
    //     }
    //   };
    //  document.addEventListener("keydown", handleKeyDown);
    //  document.body.addEventListener("contextmenu", disableContextMenu);

    return () => {
      //  document.body.removeEventListener("contextmenu", disableContextMenu);
      //  document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  return (
    <AuthProvider>
      <BrowserRouter basename="/">
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<HomePage />} />

            <Route
              path="/lessons"
              element={
                <PrivateRoute>
                  <LessonsList />
                </PrivateRoute>
              }
            />
            <Route path="/lessons/details/:id" element={<LessonDetails />} />
            <Route
              path="/my-lessons"
              element={
                <PrivateRoute>
                  <MyLessons />
                </PrivateRoute>
              }
            />
            <Route
              path="/lessons/watch/:id"
              element={
                <PrivateRoute>
                  <LessonPlayer />
                </PrivateRoute>
              }
            />
            <Route
              path="/exams"
              element={
                <PrivateRoute>
                  <ExamsList />
                </PrivateRoute>
              }
            />
            <Route
              path="/exams/:id/start"
              element={
                <PrivateRoute>
                  <ExamPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/assessment/result/:id"
              element={
                <PrivateRoute>
                  <AssessmentResult />
                </PrivateRoute>
              }
            />
            <Route
              path="/homeworks"
              element={
                <PrivateRoute>
                  <HomeworksList />
                </PrivateRoute>
              }
            />
            <Route
              path="/homeworks/:id/start"
              element={
                <PrivateRoute>
                  <HomeworkPage />
                </PrivateRoute>
              }
            />

            <Route
              path="/my-profile"
              element={
                <PrivateRoute>
                  <ProfilePage />
                </PrivateRoute>
              }
            />
            <Route
              path="/my-profile/edit"
              element={
                <PrivateRoute>
                  <EditProfile />
                </PrivateRoute>
              }
            />

            <Route
              path="/login"
              element={
                <PublicRoute>
                  <LoginPage />
                </PublicRoute>
              }
            />

            {/* <Route
              path="register"
              element={
                <PublicRoute>
                  <RegisterPage />
                </PublicRoute>
              }
            /> */}
            <Route
              path="/my-results"
              element={
                <PrivateRoute>
                  <ResultsPage />
                </PrivateRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
